<template>
  <p class="premium-indicator">
    PREMIUM
  </p>
</template>

<script>

export default {
};

</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

  .premium-indicator {
    font-size: 10px;
    border-radius: 2px;
    padding: 4px 6px 3px 6px;
    background-color: $brand;
    color: $black;
    display: inline-block;
    line-height: 12px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// app/src/components/PremiumIndicator.vue